import { normalizeChatSeedTags, type ChatSeedTags } from "@tracify/shared";

export const CHAT_ROUTE_QUERY_PARAM = "query";
export const CHAT_ROUTE_CONTEXT_PARAM = "context";

export type ChatRouteContext = {
  seedTags?: ChatSeedTags;
};

export function buildInsightChatQuery(insightTitle: string): string {
  return `Can you analyze "${insightTitle}" and explain the key takeaways?`;
}

export function encodeChatRouteContext(context: ChatRouteContext): string {
  const normalizedSeedTags = normalizeChatSeedTags(context.seedTags);
  return JSON.stringify(
    normalizedSeedTags ? { seedTags: normalizedSeedTags } : {}
  );
}

export function decodeChatRouteContext(
  rawContextParam: string
): ChatRouteContext | null {
  try {
    const parsed = JSON.parse(rawContextParam) as ChatRouteContext;

    if (!parsed || typeof parsed !== "object") {
      return null;
    }

    if (!parsed.seedTags || typeof parsed.seedTags !== "object") {
      return {};
    }

    const normalizedSeedTags = normalizeChatSeedTags(parsed.seedTags);
    if (!normalizedSeedTags) {
      return {};
    }

    return { seedTags: normalizedSeedTags };
  } catch {
    try {
      const decoded = decodeURIComponent(rawContextParam);
      const parsed = JSON.parse(decoded) as ChatRouteContext;
      if (!parsed || typeof parsed !== "object") {
        return null;
      }
      const normalizedSeedTags = normalizeChatSeedTags(parsed.seedTags);
      if (!normalizedSeedTags) {
        return {};
      }
      return { seedTags: normalizedSeedTags };
    } catch {
      return null;
    }
  }
}
